import React from 'react';
import { TweetContentDto, TweetStatus, ContentType } from '../../api/bip-api/types';

interface TweetListItemProps {
  tweet: TweetContentDto;
  isSelected: boolean;
  onClick: () => void;
}

const getTypeBadgeColor = (contentType: ContentType): string => {
  switch (contentType) {
    case ContentType.FULL_REPORT:
      return 'bg-blue-600';
    case ContentType.SMART_MONEY:
      return 'bg-green-600';
    case ContentType.LORE:
      return 'bg-purple-600';
    default:
      return 'bg-gray-600';
  }
};

const getStatusBadgeColor = (status: TweetStatus): string => {
  switch (status) {
    case TweetStatus.PENDING:
      return 'bg-yellow-600';
    case TweetStatus.PUBLISHED:
      return 'bg-green-600';
    default:
      return 'bg-gray-600';
  }
};

const formatDateToKstIso = (dateString: string): string => {
  const date = new Date(dateString);
  // KST is UTC+9
  const kstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
  return kstDate.toISOString().slice(0, 19).replace('T', ' ');
};

const getContentSummary = (contents: string[]): string => {
  if (!contents || contents.length === 0) return '';
  const firstContent = contents[0] || '';
  if (firstContent.length <= 20) return firstContent;
  return firstContent.slice(0, 20) + '...';
};

const TweetListItem: React.FC<TweetListItemProps> = ({
  tweet,
  isSelected,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`p-3 rounded-lg cursor-pointer transition-colors border ${
        isSelected
          ? 'bg-gray-700 border-blue-500'
          : 'bg-gray-800 border-gray-700 hover:bg-gray-750 hover:border-gray-600'
      }`}
    >
      <div className="flex items-center justify-between mb-1">
        <span
          className={`px-2 py-0.5 rounded text-xs font-medium text-white ${getTypeBadgeColor(
            tweet.contentType
          )}`}
        >
          {tweet.contentType}
        </span>
        <span
          className={`px-2 py-0.5 rounded text-xs font-medium text-white ${getStatusBadgeColor(
            tweet.status
          )}`}
        >
          {tweet.status}
        </span>
      </div>
      <div className="text-gray-300 text-sm mb-1 truncate">
        {getContentSummary(tweet.contents)}
      </div>
      <div className="text-gray-500 text-xs">{formatDateToKstIso(tweet.updatedAt)}</div>
    </div>
  );
};

export default TweetListItem;
